import React from 'react';
import Creation from 'shared/layout/creation';
import useFormInputs from 'shared/migration-components/form/util';

import useCreateBonus, {
  CreateBonusProps,
  translatedCreateBonusProps,
} from '../hooks/use-create-bonus';
import useUsersSelect from 'modules/users/hooks/use-users-select';

const CreateBonus: React.FC = () => {
  const {getSelect, getNumberInput} = useFormInputs<CreateBonusProps>();
  const usersSelect = useUsersSelect();

  return (
    <Creation<CreateBonusProps>
      titleBar={{title: 'Cadastrar bônus'}}
      onSubmit={useCreateBonus}
      inputs={[
        getSelect({
          name: 'userId',
          data: usersSelect.data,
          isLoading: usersSelect.isLoading,
        }),
        getNumberInput({name: 'bonus'}),
      ]}
      translationKey={translatedCreateBonusProps}
    />
  );
};

export default CreateBonus;
